import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPeopleEdit"><Path d="M13.9995 22V19.5L19.9995 13.5L22.4995 16L16.4995 22H13.9995Z" fill="currentColor"/><Path d="M12.4995 21V18.8789L17.1371 14.2413C15.7697 13.1514 14.0171 12.5 11.9996 12.5C7.38371 12.5 4.15432 15.9097 3.75289 20.1798L3.67578 21H12.4995Z" fill="currentColor"/><Path d="M11.9995 2C9.51423 2 7.49951 4.01472 7.49951 6.5C7.49951 8.98528 9.51423 11 11.9995 11C14.4848 11 16.4995 8.98528 16.4995 6.5C16.4995 4.01472 14.4848 2 11.9995 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleEdit;
